/**
 * Created by Daniela on 12/09/2016.
 */
export class MaterialCodigoBarra {
  ativo: boolean;
  dataCriacao: Date;
  dataUltimaAlteracao: Date;
  codigoBarra: string;
  id: number;
  materialId: number;
  usuarioCriacaoId: number;
  usuarioUltimaAlteracaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/shared/material-codigo-barra.model.ts
 **/